// VTX: Klaviyo popup close safety net (for visitors with Reduce Motion on)
(function(){
  function cleanup(){
    try{
      var pop=document.querySelector('[aria-label="POPUP Form"]');
      if(!pop)return;
      var root=pop.closest('.needsclick')||pop;
      var wrap=root.parentElement&&root.parentElement!==document.body?root.parentElement:root;
      wrap.style.setProperty('display','none','important');
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
      document.body.style.overflow='';
      document.documentElement.style.overflow='';
    }catch(e){}
  }
  document.addEventListener('click',function(e){
    try{
      var btn=e.target&&e.target.closest&&e.target.closest('button[aria-label="Close dialog"]');
      if(!btn||!btn.closest('[aria-label="POPUP Form"]'))return;
      setTimeout(function(){ if(document.querySelector('[aria-label="POPUP Form"]'))cleanup(); },700);
    }catch(err){}
  },true);
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&document.querySelector('[aria-label="POPUP Form"]'))setTimeout(cleanup,700);
  });
})();
